import Client from '../HttpClient';

const baseUrl = '/gateway/numbat-api/api/vs/manage-tanda-merchant';

const list = (merchantId) => {
	return Client.get(`${baseUrl}/${merchantId}/merchantSettings`, {
		status: 0,
	});
};

const find = (merchantId) => {
	return Client.get(`${baseUrl}/${merchantId}/merchantSettings`);
};

const create = (merchantId, token, operateBy) => {
	return Client.post(`${baseUrl}/${merchantId}/merchantSettings`, {
		token,
		operateBy,
	});
};

const update = (merchantId, token, operateBy) => {
	return Client.put(`${baseUrl}/${merchantId}/merchantSettings`, {
		token,
		operateBy,
	});
};

const remove = (merchantId, operateBy) => {
	return Client.del(`${baseUrl}/${merchantId}/merchantSettings`, {
		operateBy,
	});
};

export default {
	list,
	find,
	create,
	update,
	remove,
};
